import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { PhoneOption } from 'src/app/pages/phones/models/phone-option.interface';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { phoneOptionSelectors } from '../state/phone-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: PhoneSelectComponent,
        },
    ],
    selector: 'ndt-phone-select',
    templateUrl: './phone-select.component.html',
    standalone: false
})
export class PhoneSelectComponent extends LcsSingleSelectBase<PhoneOption> implements OnInit {
   phones: Observable<PhoneOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.phones = this.store.pipe(select(phoneOptionSelectors.selectFilteredItems), this.itemsLoaded());
   }

   displayWith(item: PhoneOption | null): string | null {
      if (item) {
         const details = this.getFormattedDetails(item);
         return `${item.phoneType} - ${details}`;
      }
      return null;
   }

   trackBy(item: PhoneOption | null) {
      return item ? item.phoneId : null;
   }

   getFormattedDetails(phone): string {
      if (phone.phoneType === 'Softphone') {
         return phone.sipUsers.map((sipUser) => sipUser.userName).join(', ');
      } else if (phone.phoneType === 'Hardphone') {
         return phone.devices.map((device) => device.macAddress).join(', ');
      }
      return '';
   }
}
